import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';
import { ResponseData } from '../../nest-responses';
import { CalendarDetailLeave } from '../dto/leave.dto';

@Injectable()
export class LeaveCalendarApi {

  private readonly model: string = 'calendarLeave';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getCalendarLeave(payload: any): Observable<ResponseData<String[]>> {
    const method: string = 'POST';
    const func: string = 'getCalendarLeave';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, null);
    return this.nestApiProvider.request<ResponseData<String[]>>(method, url, params, urlParams, body);
  }

  public getCalendarLeaveDetail(payload: any): Observable<ResponseData<CalendarDetailLeave[]>> {
    const method: string = 'POST';
    const func: string = 'getCalendarLeaveDetail';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, null);
    return this.nestApiProvider.request<ResponseData<CalendarDetailLeave[]>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/leave-calendar.api.ts